import { xUnits } from '../../../UNSAFE_Theme/utils';

export const scaleSchemeSm = {
  iconSize: '',
  sizes: {
    xs: {
      iconSize: 'max(' + xUnits(5) + ', 20px)'
    },
    sm: {
      iconSize: xUnits(5)
    },
    md: {
      iconSize: xUnits(5.333)
    },
    lg: {
      iconSize: xUnits(5.333)
    },
    embeddedxs: {
      iconSize: 'max(' + xUnits(5) + ', 20px)'
    },
    embeddedsm: {
      iconSize: xUnits(5)
    },
    embeddedmd: {
      iconSize: xUnits(5.333)
    },
    embeddedlg: {
      iconSize: xUnits(5.333)
    }
  }
};
